import React, { Component } from "react";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import { putRequest } from "../../utils/httpRequest";
import AlertIcon from "../../components/Notifications/AlertIcon";

interface Props {
  notification: any;
  history?: any;
}

interface State {
  showNotification: boolean;
}

class Notification extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      showNotification: true,
    };
  }

  componentDidMount() {
    $(document).on("click", "span[data-url]", function (e) {
      window.open($(this).data("url"), "_blank");
    });
  }

  visitNotificationHref = (e) => {
    const { notification } = this.props;
    // setTimeout(() => {
    //   this.closeNotification(notification);
    // }, 200);
  };

  closeNotification = (e) => {
    e.preventDefault();

    const { notification } = this.props;

    ($(`.toast-${notification.id}`) as any).transition("fly left");
    return putRequest(
      `/api/notifications/${this.props.notification.id}/mark_as_seen.json`,
      {},
    )
      .then(() => this.setState({ showNotification: false }))
      .catch((error) =>
        (window as any).honeybadger?.notify(
          `Error updating recent notification for ${notification.id}, data: ${error.response.data}`,
        ),
      );
  };

  render() {
    const { notification } = this.props;
    const { showNotification } = this.state;
    return (
      <>
        {showNotification && (
          <a
            className={`toast toast-${notification.id}`}
            href="#"
            onClick={this.closeNotification}
          >
            <AlertIcon notification={notification} baseClass="notif-ic" />
            <div className="notif-body">
              <span className="notif-text">
                <strong>
                  {/* @ts-ignore */}
                  {ReactHtmlParser(notification.title)}
                </strong>{" "}
                {/* @ts-ignore */}
                {ReactHtmlParser(notification.body)}
              </span>
              {notification.target_name && (
                <Link
                  className="notif-target"
                  to={notification.href}
                  onClick={this.visitNotificationHref}
                >
                  {/* @ts-ignore */}
                  {ReactHtmlParser(notification.target_name)}
                </Link>
              )}
            </div>
            <span className="toast-close" aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path
                  d="M6 6l12 12M18 6L6 18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </span>
          </a>
        )}
      </>
    );
  }
}

export default Notification;
